'use strict';

var zIndex$1 = require('../../../../_virtual/zIndex.js_commonjs-exports.js');

Object.defineProperty(zIndex$1.__exports, "__esModule", {
  value: true
});
zIndex$1.__exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var _default = zIndex;
zIndex$1.__exports.default = _default;
